module.exports = __webpack_public_path__ + "static/media/IMAGEN-GLUK.dfc0c4f9.png";